import { query, mutation } from '@/dex-shared/helpers/graphql';

export default {
  state: {
    examinationBoards: [],
    examinationBoard: null,
  },
  getters: {
    currentExaminationBoard: (state: any) => {
      return state.examinationBoard;
    },
  },
  mutations: {
    SET_EXAMINATION_BOARD(state: any, examinationBoard: any) {
      state.examinationBoard = examinationBoard;
    },
    SET_EMPTY_EXAMINATION_BOARD(state: any, mutations: any) {
      let examinationBoard = {
        id: null,
        title: '',
      };
      state.examinationBoard = examinationBoard;
    },
    REMOVE_QUESTION(state: any, index: number) {
      state.questions.splice(index, 1);
    },
  },
  actions: {
    async PULL_EXAMINATION_BOARD({ commit }: any, examinationBoardId: number) {
      let response = await query(
        `query pullExaminationBoard ($examinationBoardId: Int!) {
        examinationBoardById(id: $examinationBoardId) {
          id
          title
        }
      }`,
        {
          examinationBoardId,
        },
      );
      if (response.data.examinationBoardById) {
        commit('SET_EXAMINATION_BOARD', response.data.examinationBoardById);
      }
    },

    async PUSH_EXAMINATION_BOARD(
      { commit, state, rootState, getters }: any,
      examinationBoard: any,
    ) {
      let userId = rootState.auth.user ? rootState.auth.user.id : null;
      let response;
      let examinationBoardResponse;
      if (examinationBoard.id != null) {
        response = await mutation(
          `mutation updateExaminationBoard ($examinationBoardId: Int!, $title: String!) {
              updateExaminationBoardById(
                input: {
                  id: $examinationBoardId,
                  examinationBoardPatch:{
                    title: $title
                  }
                }
              ){
                examinationBoard {
                  id
                  title
                }
              }
            }`,
          {
            examinationBoardId: examinationBoard.id,
            title: examinationBoard.title,
          },
        );
        examinationBoardResponse =
          response.data.updateExaminationBoardById.examinationBoard;
      } else {
        response = await mutation(
          `mutation createExaminationBoard ($userId: Int!, $title: String!) {
              createExaminationBoard(
                input: {
                  examinationBoard: {
                    userId: $userId,
                    title: $title
                  }
                }
              ) {
                examinationBoard {
                  id
                  title
                }
              }
            }`,
          {
            userId: userId,
            title: examinationBoard.title,
          },
        );
        examinationBoardResponse =
          response.data.createExaminationBoard.examinationBoard;
      }
      //TODO error inputing examinationBoard

      if (examinationBoardResponse != null) {
        commit('SET_EXAMINATION_BOARD', examinationBoard);
      }
    },
  },
};
